import React from 'react';
import {useAccentColor, AccentColorProps} from 'epic-ue-theme';

export const FeaturesChatIcon = ({accentColor = 'sky'}: AccentColorProps): JSX.Element => {
    const stroke = useAccentColor(accentColor);

    return (
        <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M43.6333 29.7478C43.6333 30.9743 43.1461 32.1506 42.2788 33.0179C41.4115 33.8851 40.2352 34.3724 39.0087 34.3724H11.261L2.01172 43.6216V6.62463C2.01172 5.3981 2.49895 4.22181 3.36624 3.35452C4.23353 2.48724 5.40982 2 6.63634 2H39.0087C40.2352 2 41.4115 2.48724 42.2788 3.35452C43.1461 4.22181 43.6333 5.3981 43.6333 6.62463V29.7478Z"
                stroke={stroke}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M43.6333 13.3515H67.3871C68.6136 13.3515 69.7899 13.8387 70.6572 14.706C71.5245 15.5733 72.0117 16.7496 72.0117 17.9761V54.9731L62.7625 45.7239H35.0147C33.7882 45.7239 32.6119 45.2366 31.7446 44.3694C30.8773 43.5021 30.3901 42.3258 30.3901 41.0993V34.6353"
                stroke={stroke}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
